import PropTypes from 'prop-types'
import Clickable from 'components/clickable'
import Input from 'components/forms/input'
import css from '../store-search.scss'

const addonStyle = {
  border: 'none',
  color: '#6e3264',
  borderRadius: '20px 0 0 20px',
  padding: '10px 5px 10px 18px',
}

const SearchModalTrigger = ({ value, onClick }) => (
  <Clickable
    onClick={onClick}
    aria-label="Open search modal"
    className={`input-search container ${css['store-search']}`}
  >
    <Input
      aria-hidden
      value={value}
      addonStyle={addonStyle}
      groupClassName="mtl mbn"
      placeholder="What are you looking for?"
      maxLength="100"
      addonBefore={<i className="fa fa-search" />}
    />
  </Clickable>
)

SearchModalTrigger.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default SearchModalTrigger
